vsr-icon-card {
  --font-family: "Visa Dialect", sans-serif;
  display: block;
  font-family: var(--font-family);
  box-sizing: border-box;
}

.vsr-icon-card_container-light {
  --icon-card-bg: transparent;
  --icon-card-title: #1a1a1a;
  --icon-card-title-hover: #1434cb;
  --icon-card-desc: #656565;
  --icon-card-button: #1a1a1a;
  --icon-card-button-hover: #1434cb;
}

.vsr-icon-card_container-dark {
  --icon-card-bg: #1a1a1a;
  --icon-card-title: #ffffff;
  --icon-card-title-hover: #8f9fe4;
  --icon-card-desc: #dedede;
  --icon-card-button: #ffffff;
  --icon-card-button-hover: #8f9fe4;
}

.vsr-icon-card_container {
  display: flex;
  flex-direction: row;
  border: none;
  box-shadow: none;
  width: auto;
  box-sizing: border-box;
  justify-content: start;
  padding: 12px;
  gap: 12px;
  background-color: var(--icon-card-bg);
  @media (min-width: 768px) {
    padding: 32px;
    min-height: 350px;
    max-width: 300px;
    flex-direction: column;
    justify-content: space-between;
  }

  & .vsr-icon-card_image {
    & img {
      max-width: 64px;
      object-fit: cover;
      @media (min-width: 768px) {
        max-width: 100px;
      }
    }
  }

  & .vsr-icon-card_info {
    & .vsr-icon-card__title {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.4;
      color: var(--icon-card-title);
      text-decoration: none;
      cursor: default;
      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 1.3;
      }
      p {
        margin: 0;
      }
    }

    /* Hover effect only applied when has-card-link class is present */

    .vsr-icon-card__title:focus {
      color: var(--icon-card-title-hover);
      outline: 2px dashed var(--icon-card-title-hover);
      outline-offset: 2px;
    }

    & .vsr-icon-card__description {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.3;
      color: var(--icon-card-desc);
      @media (min-width: 768px) {
        font-size: 14px;
        line-height: 1.5;
      }
      p {
        margin: 0;
      }
    }

    .vsr-icon-card__action-button {
      margin-top: 20px;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      gap: 2px;
      transition: color 0.2s;
      display: none;
      @media (min-width: 768px) {
        display: block;
      }
    }

    .vsr-icon-card__action-button_link {
      text-decoration: none;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.4;
      color: var(--icon-card-button);
      &:hover {
        color: var(--icon-card-button-hover);
      }
    }

    .vsr-icon-card__action-button_link svg {
      margin-left: 6px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.vsr-icon-card_container.has-card-link:not(.no-hover-16-9) .vsr-icon-card__title:hover {
  color: var(--icon-card-title-hover);
}

/* Remove hover effect on title for 16:9 aspect ratio */
.vsr-icon-card_container.no-hover-16-9 .vsr-icon-card__title:hover {
  color: var(--icon-card-title);
}

/* Aspect ratio classes for icon card */
.vsr-icon-card_image.aspect-ratio-3-4 .vsr-icon-card_img {
  aspect-ratio: 3 / 4;
}

.vsr-icon-card_image.aspect-ratio-4-3 .vsr-icon-card_img {
  aspect-ratio: 4 / 3;
}

.vsr-icon-card_image.aspect-ratio-4-5 .vsr-icon-card_img {
  aspect-ratio: 4 / 5;
}

.vsr-icon-card_image.aspect-ratio-16-9 .vsr-icon-card_img {
  aspect-ratio: 16 / 9;
}

.vsr-icon-card_image.aspect-ratio-1-1 .vsr-icon-card_img {
  aspect-ratio: 1 / 1;
}
